import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CompanyService } from '../services/company-service';
import { catchError, of } from 'rxjs';


export const companyResolver: ResolveFn<any> = (route, state) => {
  const companyService = inject(CompanyService);
  const id = route.paramMap.get('id');
  if (!id) {
    return of(null);
  }
  return companyService.getCompanyById(id).pipe(
    catchError(() => of(null))
  );
};

